module.exports = __webpack_public_path__ + "assets/img/btn-download-xbox-07f58ca8.png";